import { defineStore } from 'pinia'

interface ConfirmState {
  message: string | null
  resolver: ((result: boolean) => void) | null
}

/**
 * ブラウザ標準の confirm() の代わりに使う、画面中央表示の確認モーダル。
 * 使い方: if (!(await confirmStore.ask('本当に削除しますか？'))) return
 */
export const useConfirmModalStore = defineStore('confirmModal', {
  state: (): ConfirmState => ({
    message: null,
    resolver: null,
  }),
  actions: {
    ask(message: string): Promise<boolean> {
      this.message = message
      return new Promise<boolean>((resolve) => {
        this.resolver = resolve
      })
    },
    resolve(result: boolean) {
      this.resolver?.(result)
      this.message = null
      this.resolver = null
    },
  },
})
